import React, { Component } from "react"
import './index.css';
import ColoredTD from './colored_td.js'
import ReactLoading from 'react-loading';
import moment from 'moment';
import store from "./store/index";
import ColoredBoxes from './components/UI/ColoredBoxes'
import WinnerBox from './components/UI/WinnerBox'
import BfLogin from './bfLogin'
import { getLoginToken, ODD_API } from "./constants/utils";
import axios from "axios";
import BfQuickResult from "./bfQuickResult";
import { Form } from 'react-bootstrap'
import { updateBetMarket } from "./actions";

const textStyle1 = {
  fontSize: '12px',
}

const runnerNameDiv = { alignItems: 'baseline', display: 'flex' }

const alignCenter = {
  align: "center",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block"

}

const marginStyle = {
  marginTop: '20px',
}
const headStyle1 = {
  color: '#21ffe4',
  fontSize: '13px',
  marginLeft: '20px',
  fontfamily: 'Roboto',
  display: 'inline-block',
  fontWeight: 'bold',
  width: '65%',
  marginTop: '10px'
};
const headStyle2 = {
  color: 'rgb(247, 246, 198)',
  fontSize: '12px',
  marginLeft: '10px',
  fontfamily: 'Roboto',
  display: 'inline-block',
  fontWeight: 'bold',
  // width: '40%',
  marginTop: '10px'
};
const runnersCount = {
  textAlign: 'right',
}

const responseBody = {
  "marketOdds": []
}

const postRequestPara = {
  "marketIds": [
    "1.156717370"
  ],
  "timePoints": [
    "t1-20190327-13:55:00",
    "t2-20190327-14:10:00",
    "t3-20190327-14:40:00",
    "t4-20190327-14:45:00",
    "t5-20190327-14:50:00",
    "t6-20190327-14:55:00"
  ]
}

class RightTable extends Component {
  timer = null;

  constructor(props) {
    super(props)
    this.state = {
      runnersOddsAtTimes: {
        test: "test",
      },
      timeDifference: null,
      suspended: false,
      marketId: null
    };
  }
  checkSuspended = () => {
    const marketId = this.props.marketId
    const token = getLoginToken();
    if (marketId && token) {
      const postRequestPara = {
        "requests":
          [{ "marketId": marketId, "selectionId": 1234567 }],
        "ssoid": token,
      }
      axios.post(ODD_API, postRequestPara)
        .then((res) => {
          const oddDetails = res.data
          if (oddDetails && oddDetails.length > 0) {
            this.setState({ suspended: oddDetails[0].status != 'OPEN' });
          }
        },
          (error) => {
            //console.log("Result of API 3 returns Error!!!" + error)
          });
    }
  }

  selectBetMarket = async (selectedMarketName, selectedMarketId) => {
    store.dispatch(updateBetMarket({ "marketId": selectedMarketId, "type": selectedMarketName }));
  }


  getLabel = (marketName, winnercount) =>{
    if(winnercount){
      return marketName + "(Winners:" + winnercount + ")";
    }
  return marketName;
  }


  getMarkets = () => {
    var marketList = this.props.firstItem.marketInfoMarketId;
    var winnerCount = this.props.firstItem.marketWinnerCount;
    if (!marketList) {
      return;
    }
    var selectedMarket =  store.getState().betMarket ? store.getState().betMarket.type :  "Win";
    return <>{Object.keys(marketList).map(x => <Form.Check
      type='radio'
      key={x}
      checked={selectedMarket === x}
      name="group1"
      label={this.getLabel(x, winnerCount[x])}
      style={{ marginLeft: "20px" }}
      onChange={() => { this.selectBetMarket(x, marketList[x]) }}
    />)}</>;

  }

  checkDelay = () => {
    //Dont update timer for suspended race.
    if (this.state.suspended && this.state.marketId === this.props.marketId) {
      return;
    }
    this.setState({ marketId: this.props.marketId })
    const raceStartTimeInLocal = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    const currentTime = moment().utcOffset(store.getState().localTimeOffSetToGmt)
    var hrs = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("HH");
    var min = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("mm");
    var sec = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("ss");
    const diff = raceStartTimeInLocal.diff(currentTime);
    //console.log("timer 123:" + diff)
    if (diff > 0) {
      const diff = <div style={{ color: "#08e64f" }}>Time Until Start: {hrs + ":" + min + ":" + sec}</div>
      this.setState({ timeDifference: diff });
    } else {
      var hrs = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("HH");
      var min = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("mm");
      var sec = moment.utc(currentTime.diff(raceStartTimeInLocal)).format("ss");
      const diff = <div style={{ color: "#a80909" }}>Time Until Start: -{hrs + ":" + min + ":" + sec}</div>
      this.setState({ timeDifference: diff });
    }
   
  }
  async componentDidMount() {
    this.timer = setInterval(
      () => {
        this.checkDelay();
        this.checkSuspended();
      },
      5000,
    );
  }
  componentWillUnmount() {
    //clearTimeout(this.timer);
  }



  convertGMTtoLocalTime = gmtTime => {
    if (gmtTime !== null) {
      return moment(gmtTime)
    }
    return null;
  };

  getTotalMatched = () => {
    let totalMatched = 0
    this.props.secondItem.forEach(runnerElement => {
      const matchedValue = runnerElement.volumeMatched ? runnerElement.volumeMatched : 0
      totalMatched += matchedValue
    }
    )
    return totalMatched.toFixed(0)
  }

  getOverRound = () => {
    let result = 0
    this.props.secondItem.forEach(runnerElement => {
      const currentPrice = runnerElement.currentPrice ? runnerElement.currentPrice : 0
      if (currentPrice > 1) {
        result += 100 / currentPrice
      }
    }
    )
    return result.toFixed(2)
  }

  getActiveRunners = () => {
    let result = 0
    this.props.secondItem.forEach(runnerElement => {
      if (runnerElement.status === 'ACTIVE') {
        result++
      }
    }
    )
    return result
  }


  numberStyles = {
    color: '#f4e1f0'
  }

  render() {

    const raceStartTimeInLocal = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    const currentRaceInLocalTime = raceStartTimeInLocal.format('YYYY-MM-DD HH:mm');
    const currentTime = moment().utcOffset(store.getState().localTimeOffSetToGmt)
    var hrs = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("HH");
    var min = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("mm");
    var sec = moment.utc(raceStartTimeInLocal.diff(currentTime)).format("ss");
    //console.log("RIght table updated with new value :: " + this.props.firstItem);
    //console.log("Runners count :: " + this.props.secondItem.length);
    let date = String(this.props.firstItem["date"])
    //console.log("date : dfdf " + date);
    var tableHeader = <p class="font-weight-bold" style={headStyle1}>Selected Race:  Loading ... wait.. </p>
    if (date !== "undefined") {
      const latestOddsTime = this.convertGMTtoLocalTime(this.props.firstItem['latestOddTimestamp']);
      // let raceDelayed = false;
      // if(latestOddsTime > raceStartTimeInLocal) raceDelayed = true;
      //log("latestOddsTime:" + latestOddsTime)
      tableHeader = <p class="font-weight-bold" style={headStyle1}>
        <span id="selectedMarketDetails">{currentRaceInLocalTime} - {this.props.firstItem["venue"]} - {this.props.firstItem["marketName"]}</span>
        <span style={{ color: 'rgb(247, 246, 198)' }}>{"  -  (Last odds update at - " + latestOddsTime.format('HH:mm:ss') + ")"}</span>
        <span style={{ color: 'rgb(247, 246, 198)', marginRight: "280px", float: "right", display:"flex" }}>
          {this.state.timeDifference}
          { this.getMarkets() }
          </span>

      </p>
    }

    let loadingElement = null
    let keysArray = Object.keys(this.props.secondItem)
    //console.log("LOADING STILL intial Right table: " + keysArray.length);
    if (keysArray.length > 0) {
      //console.log("LOADING STILL finised dfdfdfd ghgh ");
      loadingElement = null
    } else {
      //console.log("LOADING STILL");
      loadingElement = <ReactLoading type="bars" color="green" width={200} height={200} className="alignCenter24" />

    }

    let colSpan = 1
    let thStyle = {}
    if (this.props.displayTicks) {
      colSpan = 2
      thStyle = {
        textAlign: 'center'
      }
    }

    return (
      <div class="divStyle1">
        <div>
          {tableHeader}
          <div style={headStyle2}>
            <p class="wefw"><span>Overround: <span style={this.numberStyles}>{this.getOverRound()}</span></span>&nbsp;&nbsp;<span>Matched: $<span style={this.numberStyles}>{this.getTotalMatched()}</span></span>&nbsp;&nbsp;<span>Runners: </span><span style={this.numberStyles}>{this.getActiveRunners()}/{Object.keys(this.props.secondItem).length}</span></p>
          </div>
        </div>
        <div class="blockSize2 blockSpacing">
          <table class="table table-striped table-light" style={textStyle1} id="runner_Odds_Table" >
            <thead>
              <tr>
                <th scope="col">Runner</th>
                <th scope="col" colSpan="2" style={{ textAlign: "center" }}>Current Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T1</th>
                <th scope="col">T1 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T2</th>
                <th scope="col">T2 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T3</th>
                <th scope="col">T3 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T4</th>
                <th scope="col">T4 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T5</th>
                <th scope="col">T5 Price</th>
                <th scope="col" colSpan={colSpan} style={thStyle}>T6</th>
                <th scope="col">T6 Price</th>
                <th scope="col">Place Bet({store.getState().betMarket?.type})</th>
              </tr>
            </thead>
            <tbody>
              {
                { runner: "john", currentPrice: "23.4", t1: "n/a", t1Price: "", t2: "n/a", t2Price: "", t3: "n/a", t3Price: "", t4: "n/a", t4Price: "", t5: "n/a", t5Price: "", t6: "n/a", t6Price: "" },

                this.props.secondItem.map(runnerElement => {
                  let winnerInfo = null;
                  if (this.props.winnerInfo !== null && this.props.winnerInfo !== "") {
                    if (this.props.winnerInfo.winner === runnerElement.selectionId) {
                      winnerInfo = <WinnerBox type="W" />
                    }

                    if (this.props.winnerInfo.places !== null && this.props.winnerInfo.places.length > 0) {
                      if (this.props.winnerInfo.places.includes(runnerElement.selectionId)) {
                        winnerInfo = <WinnerBox type="P" />
                      }
                    }
                  }

                  return (
                    <tr key={runnerElement.name}>
                      <td className="RunnerMetaData">

                        <div style={runnerNameDiv}><div>{runnerElement.name}</div>{winnerInfo}</div>
                      </td>
                      <td style={{ paddingRight: 0 }}>{runnerElement.currentPrice}</td>
                      <td style={{ paddingLeft: 0 }}><ColoredBoxes runnerElement={runnerElement} /></td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t1} priceAtTime={runnerElement.t1Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t1Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t2} priceAtTime={runnerElement.t2Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t2Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t3} priceAtTime={runnerElement.t3Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t3Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t4} priceAtTime={runnerElement.t4Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t4Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t5} priceAtTime={runnerElement.t5Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t5Price}</td>
                      <ColoredTD displayResult={this.props.displayResult} displayTicks={this.props.displayTicks} value={runnerElement.t6} priceAtTime={runnerElement.t6Price} currentPrice={runnerElement.currentPrice} />
                      <td>{runnerElement.t6Price}</td>
                      <td scope="col">
                        <BfLogin
                          marketId={this.props.marketId}
                          marketName={this.props.firstItem}
                          suspended={this.state.suspended}
                          selectionId={runnerElement.selectionId}
                          runner={runnerElement}
                          odd={runnerElement.currentPrice}>
                        </BfLogin></td>
                    </tr>
                  )
                }
                )
              }
            </tbody>
          </table>
          <div>
            {getLoginToken() ?
              <BfQuickResult marketId={this.props.marketId} showDateDropDown="false" refreshTime="2000"
                type="current" filterStatus="EXECUTABLE"></BfQuickResult>
              : null
            }
          </div>
          <div style={alignCenter}>
            {loadingElement}
          </div>
        </div>
      </div>


    )
  }
}
export default RightTable
